const countryIsoCode = DLG.config.currentCountryIsocode === 'US' ? 3100 : 5000;
export const MAX_DISTANCE = countryIsoCode;
export const DEFAULT_DISTANCE = 100;

export const LAT_LNG = {
  ad: { latitude: 42.546245, longitude: 1.601554 },
  ae: { latitude: 23.424076, longitude: 53.847818 },
  af: { latitude: 33.93911, longitude: 67.709953 },
  ag: { latitude: 17.060816, longitude: -61.796428 },
  ai: { latitude: 18.220554, longitude: -63.068615 },
  al: { latitude: 41.153332, longitude: 20.168331 },
  am: { latitude: 40.069099, longitude: 45.038189 },
  an: { latitude: 12.226079, longitude: -69.060087 },
  ao: { latitude: -11.202692, longitude: 17.873887 },
  aq: { latitude: -75.250973, longitude: -0.071389 },
  ar: { latitude: -38.416097, longitude: -63.616672 },
  as: { latitude: -14.270972, longitude: -170.132217 },
  at: { latitude: 47.516231, longitude: 14.550072 },
  au: { latitude: -25.274398, longitude: 133.775136 },
  aw: { latitude: 12.52111, longitude: -69.968338 },
  az: { latitude: 40.143105, longitude: 47.576927 },
  aa: { latitude: 43.915886, longitude: 17.679076 },
  bb: { latitude: 13.193887, longitude: -59.543198 },
  bd: { latitude: 23.684994, longitude: 90.356331 },
  be: { latitude: 50.503887, longitude: 4.469936 },
  bf: { latitude: 12.238333, longitude: -1.561593 },
  bg: { latitude: 42.733883, longitude: 25.48583 },
  bh: { latitude: 25.930414, longitude: 50.637772 },
  bi: { latitude: -3.373056, longitude: 29.918886 },
  bj: { latitude: 9.30769, longitude: 2.315834 },
  bm: { latitude: 32.321384, longitude: -64.75737 },
  bn: { latitude: 4.535277, longitude: 114.727669 },
  bo: { latitude: -16.290154, longitude: -63.588653 },
  br: { latitude: -14.235004, longitude: -51.92528 },
  bs: { latitude: 25.03428, longitude: -77.39628 },
  bt: { latitude: 27.514162, longitude: 90.433601 },
  bv: { latitude: -54.423199, longitude: 3.413194 },
  bw: { latitude: -22.328474, longitude: 24.684866 },
  by: { latitude: 53.709807, longitude: 27.953389 },
  bz: { latitude: 17.189877, longitude: -88.49765 },
  ca: { latitude: 56.130366, longitude: -106.346771 },
  cc: { latitude: -12.164165, longitude: 96.870956 },
  cd: { latitude: -4.038333, longitude: 21.758664 },
  cf: { latitude: 6.611111, longitude: 20.939444 },
  cg: { latitude: -0.228021, longitude: 15.827659 },
  ch: { latitude: 46.818188, longitude: 8.227512 },
  ci: { latitude: 7.539989, longitude: -5.54708 },
  ck: { latitude: -21.236736, longitude: -159.777671 },
  cl: { latitude: -35.675147, longitude: -71.542969 },
  cm: { latitude: 7.369722, longitude: 12.354722 },
  cn: { latitude: 35.86166, longitude: 104.195397 },
  co: { latitude: 4.570868, longitude: -74.297333 },
  cr: { latitude: 9.748917, longitude: -83.753428 },
  cu: { latitude: 21.521757, longitude: -77.781167 },
  cv: { latitude: 16.002082, longitude: -24.013197 },
  cx: { latitude: -10.447525, longitude: 105.690449 },
  cy: { latitude: 35.126413, longitude: 33.429859 },
  cz: { latitude: 49.817492, longitude: 15.472962 },
  de: { latitude: 51.165691, longitude: 10.451526 },
  dj: { latitude: 11.825138, longitude: 42.590275 },
  dk: { latitude: 56.26392, longitude: 9.501785 },
  dm: { latitude: 15.414999, longitude: -61.370976 },
  do: { latitude: 18.735693, longitude: -70.162651 },
  dz: { latitude: 28.033886, longitude: 1.659626 },
  ec: { latitude: -1.831239, longitude: -78.183406 },
  ee: { latitude: 58.595272, longitude: 25.013607 },
  eg: { latitude: 26.820553, longitude: 30.802498 },
  eh: { latitude: 24.215527, longitude: -12.885834 },
  er: { latitude: 15.179384, longitude: 39.782334 },
  es: { latitude: 40.463667, longitude: -3.74922 },
  et: { latitude: 9.145, longitude: 40.489673 },
  fi: { latitude: 61.92411, longitude: 25.748151 },
  fj: { latitude: -16.578193, longitude: 179.414413 },
  fk: { latitude: -51.796253, longitude: -59.523613 },
  fm: { latitude: 7.425554, longitude: 150.550812 },
  fo: { latitude: 61.892635, longitude: -6.911806 },
  fr: { latitude: 46.227638, longitude: 2.213749 },
  ga: { latitude: -0.803689, longitude: 11.609444 },
  gb: { latitude: 55.378051, longitude: -3.435973 },
  gd: { latitude: 12.262776, longitude: -61.604171 },
  ge: { latitude: 42.315407, longitude: 43.356892 },
  gf: { latitude: 3.933889, longitude: -53.125782 },
  gg: { latitude: 49.465691, longitude: -2.585278 },
  gh: { latitude: 7.946527, longitude: -1.023194 },
  gi: { latitude: 36.137741, longitude: -5.345374 },
  gl: { latitude: 71.706936, longitude: -42.604303 },
  gm: { latitude: 13.443182, longitude: -15.310139 },
  gn: { latitude: 9.945587, longitude: -9.696645 },
  gp: { latitude: 16.995971, longitude: -62.067641 },
  gq: { latitude: 1.650801, longitude: 10.267895 },
  gr: { latitude: 39.074208, longitude: 21.824312 },
  gs: { latitude: -54.429579, longitude: -36.587909 },
  gt: { latitude: 15.783471, longitude: -90.230759 },
  gu: { latitude: 13.444304, longitude: 144.793731 },
  gw: { latitude: 11.803749, longitude: -15.180413 },
  gy: { latitude: 4.860416, longitude: -58.93018 },
  gz: { latitude: 31.354676, longitude: 34.308825 },
  hk: { latitude: 22.396428, longitude: 114.109497 },
  hm: { latitude: -53.08181, longitude: 73.504158 },
  hn: { latitude: 15.199999, longitude: -86.241905 },
  hr: { latitude: 45.1, longitude: 15.2 },
  ht: { latitude: 18.971187, longitude: -72.285215 },
  hu: { latitude: 47.162494, longitude: 19.503304 },
  id: { latitude: -0.789275, longitude: 113.921327 },
  ie: { latitude: 53.41291, longitude: -8.24389 },
  il: { latitude: 31.046051, longitude: 34.851612 },
  im: { latitude: 54.236107, longitude: -4.548056 },
  in: { latitude: 20.593684, longitude: 78.96288 },
  io: { latitude: -6.343194, longitude: 71.876519 },
  iq: { latitude: 33.223191, longitude: 43.679291 },
  ir: { latitude: 32.427908, longitude: 53.688046 },
  is: { latitude: 64.963051, longitude: -19.020835 },
  it: { latitude: 41.87194, longitude: 12.56738 },
  je: { latitude: 49.214439, longitude: -2.13125 },
  jm: { latitude: 18.109581, longitude: -77.297508 },
  jo: { latitude: 30.585164, longitude: 36.238414 },
  jp: { latitude: 36.204824, longitude: 138.252924 },
  ke: { latitude: -0.023559, longitude: 37.906193 },
  kg: { latitude: 41.20438, longitude: 74.766098 },
  kh: { latitude: 12.565679, longitude: 104.990963 },
  ki: { latitude: -3.370417, longitude: -168.734039 },
  km: { latitude: -11.875001, longitude: 43.872219 },
  kn: { latitude: 17.357822, longitude: -62.782998 },
  kp: { latitude: 40.339852, longitude: 127.510093 },
  kr: { latitude: 35.907757, longitude: 127.766922 },
  kw: { latitude: 29.31166, longitude: 47.481766 },
  ky: { latitude: 19.513469, longitude: -80.566956 },
  kz: { latitude: 48.019573, longitude: 66.923684 },
  la: { latitude: 19.85627, longitude: 102.495496 },
  lb: { latitude: 33.854721, longitude: 35.862285 },
  lc: { latitude: 13.909444, longitude: -60.978893 },
  li: { latitude: 47.166, longitude: 9.555373 },
  lk: { latitude: 7.873054, longitude: 80.771797 },
  lr: { latitude: 6.428055, longitude: -9.429499 },
  ls: { latitude: -29.609988, longitude: 28.233608 },
  lt: { latitude: 55.169438, longitude: 23.881275 },
  lu: { latitude: 49.815273, longitude: 6.129583 },
  lv: { latitude: 56.879635, longitude: 24.603189 },
  ly: { latitude: 26.3351, longitude: 17.228331 },
  ma: { latitude: 31.791702, longitude: -7.09262 },
  mc: { latitude: 43.750298, longitude: 7.412841 },
  md: { latitude: 47.411631, longitude: 28.369885 },
  me: { latitude: 42.708678, longitude: 19.37439 },
  mg: { latitude: -18.766947, longitude: 46.869107 },
  mh: { latitude: 7.131474, longitude: 171.184478 },
  mk: { latitude: 41.608635, longitude: 21.745275 },
  ml: { latitude: 17.570692, longitude: -3.996166 },
  mm: { latitude: 21.913965, longitude: 95.956223 },
  mn: { latitude: 46.862496, longitude: 103.846656 },
  mo: { latitude: 22.198745, longitude: 113.543873 },
  mp: { latitude: 17.33083, longitude: 145.38469 },
  mq: { latitude: 14.641528, longitude: -61.024174 },
  mr: { latitude: 21.00789, longitude: -10.940835 },
  ms: { latitude: 16.742498, longitude: -62.187366 },
  mt: { latitude: 35.937496, longitude: 14.375416 },
  mu: { latitude: -20.348404, longitude: 57.552152 },
  mv: { latitude: 3.202778, longitude: 73.22068 },
  mw: { latitude: -13.254308, longitude: 34.301525 },
  mx: { latitude: 23.634501, longitude: -102.552784 },
  my: { latitude: 4.210484, longitude: 101.975766 },
  mz: { latitude: -18.665695, longitude: 35.529562 },
  na: { latitude: -22.95764, longitude: 18.49041 },
  nc: { latitude: -20.904305, longitude: 165.618042 },
  ne: { latitude: 17.607789, longitude: 8.081666 },
  nf: { latitude: -29.040835, longitude: 167.954712 },
  ng: { latitude: 9.081999, longitude: 8.675277 },
  ni: { latitude: 12.865416, longitude: -85.207229 },
  nl: { latitude: 52.132633, longitude: 5.291266 },
  no: { latitude: 60.472024, longitude: 8.468946 },
  np: { latitude: 28.394857, longitude: 84.124008 },
  nr: { latitude: -0.522778, longitude: 166.931503 },
  nu: { latitude: -19.054445, longitude: -169.867233 },
  nz: { latitude: -40.900557, longitude: 174.885971 },
  om: { latitude: 21.512583, longitude: 55.923255 },
  pa: { latitude: 8.537981, longitude: -80.782127 },
  pe: { latitude: -9.189967, longitude: -75.015152 },
  pf: { latitude: -17.679742, longitude: -149.406843 },
  pg: { latitude: -6.314993, longitude: 143.95555 },
  ph: { latitude: 12.879721, longitude: 121.774017 },
  pk: { latitude: 30.375321, longitude: 69.345116 },
  pl: { latitude: 51.919438, longitude: 19.145136 },
  pm: { latitude: 46.941936, longitude: -56.27111 },
  pn: { latitude: -24.703615, longitude: -127.439308 },
  pr: { latitude: 18.220833, longitude: -66.590149 },
  ps: { latitude: 31.952162, longitude: 35.233154 },
  pt: { latitude: 39.399872, longitude: -8.224454 },
  pw: { latitude: 7.51498, longitude: 134.58252 },
  py: { latitude: -23.442503, longitude: -58.443832 },
  qa: { latitude: 25.354826, longitude: 51.183884 },
  re: { latitude: -21.115141, longitude: 55.536384 },
  ro: { latitude: 45.943161, longitude: 24.96676 },
  rs: { latitude: 44.016521, longitude: 21.005859 },
  ru: { latitude: 61.52401, longitude: 105.318756 },
  rw: { latitude: -1.940278, longitude: 29.873888 },
  sa: { latitude: 23.885942, longitude: 45.079162 },
  sb: { latitude: -9.64571, longitude: 160.156194 },
  sc: { latitude: -4.679574, longitude: 55.491977 },
  sd: { latitude: 12.862807, longitude: 30.217636 },
  se: { latitude: 60.128161, longitude: 18.643501 },
  sg: { latitude: 1.352083, longitude: 103.819836 },
  sh: { latitude: -24.143474, longitude: -10.030696 },
  si: { latitude: 46.151241, longitude: 14.995463 },
  sj: { latitude: 77.553604, longitude: 23.670272 },
  sk: { latitude: 48.669026, longitude: 19.699024 },
  sl: { latitude: 8.460555, longitude: -11.779889 },
  sm: { latitude: 43.94236, longitude: 12.457777 },
  sn: { latitude: 14.497401, longitude: -14.452362 },
  so: { latitude: 5.152149, longitude: 46.199616 },
  sr: { latitude: 3.919305, longitude: -56.027783 },
  st: { latitude: 0.18636, longitude: 6.613081 },
  sv: { latitude: 13.794185, longitude: -88.89653 },
  sy: { latitude: 34.802075, longitude: 38.996815 },
  sz: { latitude: -26.522503, longitude: 31.465866 },
  tc: { latitude: 21.694025, longitude: -71.797928 },
  td: { latitude: 15.454166, longitude: 18.732207 },
  tf: { latitude: -49.280366, longitude: 69.348557 },
  tg: { latitude: 8.619543, longitude: 0.824782 },
  th: { latitude: 15.870032, longitude: 100.992541 },
  tj: { latitude: 38.861034, longitude: 71.276093 },
  tk: { latitude: -8.967363, longitude: -171.855881 },
  tl: { latitude: -8.874217, longitude: 125.727539 },
  tm: { latitude: 38.969719, longitude: 59.556278 },
  tn: { latitude: 33.886917, longitude: 9.537499 },
  to: { latitude: -21.178986, longitude: -175.198242 },
  tr: { latitude: 38.963745, longitude: 35.243322 },
  tt: { latitude: 10.691803, longitude: -61.222503 },
  tv: { latitude: -7.109535, longitude: 177.64933 },
  tw: { latitude: 23.69781, longitude: 120.960515 },
  tz: { latitude: -6.369028, longitude: 34.888822 },
  ua: { latitude: 48.379433, longitude: 31.16558 },
  ug: { latitude: 1.373333, longitude: 32.290275 },
  um: { latitude: null, longitude: null },
  us: { latitude: 37.09024, longitude: -95.712891 },
  uy: { latitude: -32.522779, longitude: -55.765835 },
  uz: { latitude: 41.377491, longitude: 64.585262 },
  va: { latitude: 41.902916, longitude: 12.453389 },
  vc: { latitude: 12.984305, longitude: -61.287228 },
  ve: { latitude: 6.42375, longitude: -66.58973 },
  vg: { latitude: 18.420695, longitude: -64.639968 },
  vi: { latitude: 18.335765, longitude: -64.896335 },
  vn: { latitude: 14.058324, longitude: 108.277199 },
  vu: { latitude: -15.376706, longitude: 166.959158 },
  wf: { latitude: -13.768752, longitude: -177.156097 },
  ws: { latitude: -13.759029, longitude: -172.104629 },
  xk: { latitude: 42.602636, longitude: 20.902977 },
  ye: { latitude: 15.552727, longitude: 48.516388 },
  yt: { latitude: -12.8275, longitude: 45.166244 },
  za: { latitude: -30.559482, longitude: 22.937506 },
  zm: { latitude: -13.133897, longitude: 27.849332 },
  zw: { latitude: -19.015438, longitude: 29.154857 },
};

export const getFiltersSelected = (currentDistance, currentService) => {
  let tot = 0;
  if (currentDistance && currentDistance !== MAX_DISTANCE) {
    tot += 1;
  }
  if (currentService.length > 0) {
    tot += currentService.length;
  }
  return tot;
};
